<template>
	<v-app id="app">
		<div v-if="showCookies" class="text-center">
			<v-bottom-sheet v-model="snackbar" :timeout="-1" vertical>
				<v-sheet class="accent">
					<v-row justify="center" align="center">
						<v-col cols="12" md="6">
							<div class="pa-5">
								<p class="fondo--text">
									{{ $t('info.condiciones') }}
								</p>
							</div>
						</v-col>
						<v-col cols="12" md="4">
							<div class="d-flex justify-center pa-5 pa-md-0">
								<v-btn rounded outlined color="white" class="mx-2" @click="masInformacion">
									{{ $t('info.mas') }}
								</v-btn>

								<v-btn color="primary" rounded text @click="byAcceptingCookies" class="white px-5 mx-2">
									{{ $t('info.aceptar') }}
								</v-btn>
							</div>
						</v-col>
					</v-row>
				</v-sheet>
			</v-bottom-sheet>
		</div>

		<navigation />

		<v-main class="pt-0">
			<RouterView />
		</v-main>

		<v-scale-transition>
			<v-btn fab v-show="fab" v-scroll="onScroll" dark fixed bottom right color="secondary" @click="toTop">
				<v-icon>mdi-arrow-up</v-icon>
			</v-btn>
		</v-scale-transition>

		<foot />
	</v-app>
</template>

<script>
import navigation from '@/components/Navigation.vue';
import foot from '@/components/Foot.vue';

export default {
	name: 'App',

	components: {
		navigation,
		foot,
	},

	data: () => ({
		fab: null,
		snackbar: true,
		showCookies: false,
	}),

	methods: {
		byAcceptingCookies() {
			document.cookie = 'cookies_aceptadas;max-age=2592000';
			this.snackbar = false;
			this.showCookies = false;
		},

		masInformacion() {
			this.$router.push({ name: 'Coockies' });
			this.snackbar = false;
		},

		onScroll(e) {
			if (typeof window === 'undefined') return;
			const top = window.pageYOffset || e.target.scrollTop || 0;
			this.fab = top > 60;
		},

		toTop() {
			this.$vuetify.goTo(0);
			this.$router.push('/');
		},
	},

	created() {
		this.showCookies = document.cookie === '' ? true : false;
	},
};
</script>

<style>

@font-face {
  font-family: 'futura-pt';
  src: url('assets/fonts/FuturaPT-Book.woff') format('woff');
}

@font-face {
  font-family: 'futura-pt-bold';
  src: url('assets/fonts/FuturaPT-Medium.woff') format('woff');
}

html {
	/* Keyword values */
	scroll-behavior: auto;
	scroll-behavior: smooth;

	/* Global values */
	scroll-behavior: inherit;
	scroll-behavior: initial;
	scroll-behavior: revert;
	scroll-behavior: revert-layer;
	scroll-behavior: unset;

}

* {
	text-decoration: none !important;
  font-family: "futura-pt", sans-serif !important;
  /* font-size: 18px !important; */
}

#app {
	overflow-x: hidden;
  font-family: "futura-pt", sans-serif !important;
}

#container {
	max-width: 1440px;
}

.v-main {
	background-attachment: fixed;
	background-position: center;
	background-size: cover;
	background-color: #f9fafe;
}

.before-enter.anim {
	opacity: 0;
	transform: translateY(50px);
	transition: all 1.5s ease-in-out;
}
.enter.anim {
	opacity: 1;
	transform: translateY(0px);
}

.hr {
	border-top: 3px solid;
	width: 8vw;
}

.before-enter.hr {
	opacity: 0;
	transition: all 1.5s ease-in-out;
}

.enter.hr {
	opacity: 1;
}

.v-application .accent--text {
  color: #2c569F !important;
  caret-color: #2c569F !important;
}

.v-application .text-md-h3, .v-application .text-h4 {
  font-family: "futura-pt-bold", sans-serif !important;
}

.v-application .headline,
.v-application .display-1, .v-application .text-h5 {
  font-family: "futura-pt", sans-serif !important;
}

</style>
